import { Alert, AlertTitle, CircularProgress } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { httpService } from "../httpService";

function ActivateAccount() {
  const { id } = useParams();

  const [error, setError] = useState(false);

  const [loading, setLoading] = useState(false);

  const getData = async () => {
    setLoading(true);
    const { data, error } = await httpService(`verifyaccount/${id}`);

    if (data) {
      localStorage.setItem(
        process.env.REACT_APP_PROJECT_ACCOUNT,
        JSON.stringify(data)
      );
      window.location.assign("/");
    }

    if (error) {
      setError(error);
    }
    setLoading(false);
  };

  useEffect(() => {
    getData();
  }, []);
  return (
    <div>
      <div className="container mt-5">
        {loading && (
          <div className="text-center">
            <CircularProgress size={20} />
          </div>
        )}
        {error && (
          <div className="row d-flex justify-content-center">
            <div className="col-lg-5 ">
              <Alert severity="error">
                <AlertTitle>Error Activating Account</AlertTitle>
                There was a problem activating your account.
              </Alert>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

export default ActivateAccount;
